import { DataTableFilter, FilterType } from 'generated/resources/datatable.graphql'
import {
  FinanceFinancialDocumentFilter,
  FinanceValueObjectsFinancialDocumentTypeEnum,
} from 'generated/resources/graphql'

import { Filter } from 'modules/core/components/DataTable/types'
import i18n from 'modules/core/lib/i18n'

import { InvoiceFilters } from '../DataTableWrapper/types'

export const documentTypeFilter = (
  onFilterChange: (filters: InvoiceFilters) => void,
  currentDocumentTypes?: FinanceValueObjectsFinancialDocumentTypeEnum[]
): DataTableFilter<FinanceFinancialDocumentFilter> => {
  const onUpdateDocumentTypeFilter = (
    filter?: Filter<FinanceValueObjectsFinancialDocumentTypeEnum[]>
  ) => {
    const filterValue = Array.isArray(filter?.value) ? filter.value : []
    onFilterChange({ documentType: filterValue })
  }

  return {
    identifier: 'documentType',
    title: i18n.t('finance.invoices.list.fields.document_type'),
    path: 'documentType',
    type: FilterType.String,
    default: Boolean(currentDocumentTypes?.length),
    onUpdateValue: onUpdateDocumentTypeFilter,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        value: currentDocumentTypes || [],
        options: [
          {
            label: i18n.t('finance.invoices.detail.document_type.invoice'),
            value: 'invoice',
          },
          {
            label: i18n.t('finance.invoices.detail.document_type.credit_note'),
            value: 'credit_note',
          },
        ],
      },
    ],
  }
}

export const legalEntityFilter = (
  onFilterChange: (filters: InvoiceFilters) => void,
  legalEntitiesOptions: { value: number; label: string }[],
  currentLegalEntities?: number[]
): DataTableFilter<FinanceFinancialDocumentFilter> => {
  const onUpdateLegalEntityFilter = (filter?: Filter<number[]>) => {
    const filterValue = Array.isArray(filter?.value) ? filter.value : []
    onFilterChange({ legalEntity: filterValue })
  }

  return {
    identifier: 'legal_entity_id',
    title: i18n.t('finance.invoices.list.fields.legal_entity'),
    path: 'legalEntityId',
    type: FilterType.Integer,
    default: Boolean(currentLegalEntities?.length),
    onUpdateValue: onUpdateLegalEntityFilter,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        value: currentLegalEntities || [],
        options: legalEntitiesOptions,
      },
    ],
  }
}

export const validatedFilter = (
  onFilterChange: (filters: InvoiceFilters) => void,
  currentValidated?: boolean
): DataTableFilter<FinanceFinancialDocumentFilter> => {
  const onUpdateValidatedFilter = (filter?: Filter<boolean>) => {
    const filterValue = typeof filter?.value === 'boolean' ? filter.value : undefined
    onFilterChange({ validated: filterValue })
  }

  return {
    identifier: 'validatedFilter',
    title: i18n.t('finance.invoices.list.fields.validation_status'),
    path: 'validated',
    default: currentValidated !== undefined,
    type: FilterType.Boolean,
    onUpdateValue: onUpdateValidatedFilter,
    categories: [
      {
        kind: 'SingleChoice',
        value: currentValidated,
        operation: 'eq',
        options: [
          {
            label: i18n.t('finance.invoices.list.status.validated'),
            value: true,
          },
          {
            label: i18n.t('finance.invoices.list.status.not_validated'),
            value: false,
          },
        ],
      },
    ],
  }
}
